const fileList = () => import('./fileList');
const noticeList = () => import('./noticeList');
const noticeEdit = () => import('./noticeEdit');
const noticeShow = () => import('./noticeShow');
const question = () => import('./question');

const professional = () => import('./professional');// 专业列表
const langsch = () => import('./langsch');// 语言学校列表
const collegeRuleEdit = () => import('./collegeRuleEdit');// 选校规则详情
const collegeRule = () => import('./collegeRule');// 选校规则列表
const collegeRuleTool = () => import('./collegeRuleTool');// 选校规则工具

const europeRouter = [
  {
    path: '/Europe/question', name: 'question', component: question, meta: { c: 'europe', a: 'question' }
  },
  {
    path: '/Europe/fileList', name: 'fileList', component: fileList, meta: { c: 'europe', a: 'fileList' }
  },
  {
    path: '/Europe/noticeList', name: 'noticeList', component: noticeList, meta: { c: 'europe', a: 'noticeList' }
  },
  {
    path: '/Europe/noticeAdd', name: 'noticeAdd', component: noticeEdit, meta: { c: 'europe', a: 'noticeAdd' }
  },
  {
    path: '/Europe/noticeEdit/:id', name: 'noticeEdit', component: noticeEdit, meta: { c: 'europe', a: 'noticeEdit' }
  },
  {
    path: '/Europe/noticeShow/:id', name: 'noticeShow', component: noticeShow, meta: { c: 'europe', a: 'noticeShow' }
  },
  {
    path: '/Europe/professional', name: 'professional', component: professional, meta: { c: 'europe', a: 'professional' }
  },
  {
    path: '/Europe/langsch', name: 'langsch', component: langsch, meta: { c: 'europe', a: 'langsch' }
  },
  {
    path: '/Europe/collegeRuleEdit/:id', name: 'collegeRuleEdit', component: collegeRuleEdit, meta: { c: 'europe', a: 'collegeRuleEdit' }
  },
  {
    path: '/Europe/collegeRuleAdd', name: 'collegeRuleAdd', component: collegeRuleEdit, meta: { c: 'europe', a: 'collegeRuleEdit' }
  },
  {
    path: '/Europe/collegeRule', name: 'collegeRule', component: collegeRule, meta: { c: 'europe', a: 'collegeRule' }
  },
  {
    path: '/Europe/collegeRuleTool', name: 'collegeRuleTool', component: collegeRuleTool, meta: { c: 'europe', a: 'collegeRuleTool' }
  },
];

export default europeRouter;

